import { call, put, takeEvery } from "redux-saga/effects";

import { EditCompanyProfileFailure, EditCompanyProfileSuccess } from "store/actions/Settings/EditCompanyInfo";
import { EDIT_COMPANY_INFO } from "store/constants/Settings/EditCompanyInfo";

import { baseUrl } from "util/APIBaseUrl";
import postRequest from "util/APIHelperPost";

export const fetchEditCompanyProfileRequest = async (actions) => {
  // eslint-disable-next-line no-return-await
  let body = {
    companyName: actions.payload.companyProfileData.companyName,
    contactEmail: actions.payload.companyProfileData.email,
    industry: actions?.payload?.companyProfileData?.industry,
    contactPerson: actions?.payload?.companyProfileData?.contactPerson,
    contactNumber: actions?.payload?.companyProfileData?.contactNumber,
    country: actions.payload?.companyProfileData?.country,
    addressLine1: actions?.payload?.companyProfileData?.addressLine1,
    state: actions?.payload?.companyProfileData?.state,
    city: actions?.payload?.companyProfileData?.city,
    zip: actions?.payload?.companyProfileData?.zip,
  };

  body = JSON.stringify(body);

  return await postRequest(`${baseUrl}/customer/${actions.payload.customerId}/editCompanyProfile`, body)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

function* fetchEditCompanyProfile(params) {
  try {
    const response = yield call(fetchEditCompanyProfileRequest, params);
    yield put(EditCompanyProfileSuccess(response));
  } catch (error) {
    yield put(EditCompanyProfileFailure(error));
  }
}

export default function* rootSaga() {
  yield takeEvery(EDIT_COMPANY_INFO, fetchEditCompanyProfile);
}
